(function video(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.videoPlayers.vimeo.Player ||
    !global.NewHomeSource.videoPlayers.youtube.Player ||
    !global.NewHomeSource.videoPlayers.internalProvider.Player ||
    !global.NewHomeSource.FullImageViewer.PerformanceEvents ||
    !global.NewHomeSource.FullImageViewer.SegmentEvents
  ) {
    return;
  }

  let imagesContainer = global.document.querySelector(global
    .NewHomeSource.FullImageViewer.Config.queryImagesContainer);
  const previousVideo = global.NewHomeSource.FullImageViewer.Video;
  const videoContainer = global.document.createElement('div');
  const widthAttribute = 'width';
  const heightAttribute = 'height';
  const videoPlayers = {
    internalprovider: global.NewHomeSource.videoPlayers.internalProvider.Player,
    vimeo: global.NewHomeSource.videoPlayers.vimeo.Player,
    youtube: global.NewHomeSource.videoPlayers.youtube.Player,
  };
  let videoElement;

  /**
  * @private
  * displayVideo: attaches the video element to the DOM.
  *
  * @param {function} callback to execute after the video container was added to the DOM.
  */
  function displayVideo(callback) {
    imagesContainer = global.document.querySelector(global
      .NewHomeSource.FullImageViewer.Config.queryImagesContainer);

    if (!imagesContainer) {
      return;
    }

    videoContainer.innerHTML = '';
    imagesContainer.prepend(videoContainer);
    callback(this);
  }

  /**
  * @private
  * findPlayer: returns the JavaScript object that knows how to handle the given video.
  *
  * @param {object} data with the video information.
  */
  function findPlayer(data) {
    const playerName = data.VideoType.toLowerCase();
    return videoPlayers[playerName];
  }

  /**
  * @private
  * hideVideo: removes the video element from the DOM.
  */
  function hideVideo() {
    if (videoContainer.parentElement) {
      videoContainer.parentElement.removeChild(videoContainer);
    }
  }

  /**
  * @private
  * insertPlayer: creates the player inside the video container.
  *
  * @param {object} data with the video information.
  */
  function insertPlayer(data) {
    const playerToUse = findPlayer(data);
    const width = videoContainer.getAttribute(widthAttribute);
    const height = videoContainer.getAttribute(heightAttribute);

    const handler = {
      playOnLoaded: true,
      onPlaying() {
        global.NewHomeSource.FullImageViewer.PerformanceEvents.logVideo(data);
        global.NewHomeSource.FullImageViewer.SegmentEvents.logVideo(data);
      }
    };

    videoElement = playerToUse.createContainer(width, height);
    videoContainer.innerHTML = '';
    videoContainer.prepend(videoElement);
    playerToUse({
      elementId: videoElement.id,
      videoId: data.VideoId,
      videoUrl: data.VideoUrl,
      thumbnailUrl: data.ThumbnailUrl,
      eventsHandler: handler
    });
  }

  /**
   * @private
   * setSizes: sets the width and height to the canvas element.
   */
  function setSizes(data) {
    videoContainer.style.width = data.width + 'px';
    videoContainer.style.height = data.height + 'px';
    videoContainer.setAttribute(widthAttribute, data.width);
    videoContainer.setAttribute(heightAttribute, data.height);
  }

  /**
  * @private
  * resize: sets new values for the width and height of the canvas element.
  */
  function resize(data) {
    setSizes(data);
  }

  /**
   * @private
   * handleResize: checks if the topic message indicates a resize action is needed.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  function handleResize(data, topic) {
    if (topic !== 'onResize') {
      return true;
    }

    requestAnimationFrame(resize.bind(null, data));
    return false;
  }

  /**
   * @private
   * render: creates and display the video object using the player.
   *
   * @param {object} data information of the object to be rendered.
   */
  function render(data) {
    requestAnimationFrame(displayVideo.bind(data, insertPlayer));
    return !!data;
  }

  /**
  * @private
  * shouldBeIgnored: hides the Video element if the current element does not have a video ID.
  *
  * @param {object} data information that was changed.
  */
  function shouldBeIgnored(data) {
    const isVideo = !!data.VideoId;

    if (!isVideo && videoContainer.parentElement) {
      hideVideo();
    }

    return isVideo;
  }

  /**
   * @constructs NewHomeSource.FullImageViewer.Video
   */
  function Video() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  Video.update = function update(data, topic) {
    global.NewHomeSource.Pipe.conditionalPipe(handleResize, shouldBeIgnored, render)(data, topic);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.Video to the previous script.
   */
  Video.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.Video = previousVideo;
    return Video;
  };

  videoContainer.id = 'fullImageViewerVideoContainer';
  global.NewHomeSource.FullImageViewerState.add('onImageSet', Video);
  global.NewHomeSource.FullImageViewerState.add('onResize', Video);
  global.NewHomeSource.FullImageViewer.Video = Video;
}(window));
